module.exports = __webpack_public_path__ + "img/rouge-6.b72ec392.png";